var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contractdetail"},[_c('nav-bar'),_vm._v(" "),_c('search-bar'),_vm._v(" "),_c('div',{staticClass:"main "},_vm._l((_vm.imgs),function(i,k){return _c('img',{key:k,staticStyle:{"width":"300px","height":"300px"},attrs:{"src":i,"alt":""}})}),0),_vm._v(" "),_c('footer-bar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f130f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/me/merchantsContract/detail.vue
// module id = C0i3
// module chunks = 2